import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "clear"];

  connect() {
    this.refreshClear();
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.element.closest("form").requestSubmit();
    }
  }

  clear() {
    this.inputTarget.value = "";
    this.refreshClear();
    this.element.closest("form").requestSubmit();
  }

  refreshClear() {
    if (this.hasClearTarget) {
      this.clearTarget.hidden = this.inputTarget.value === "";
    }
  }
}
